import React, { Component } from 'react';

import './Footer.css';

class Footer extends Component {
    render() {
        return (
            <footer className="py-3">
                <p className="m-0 text-center text-white">&copy; 2018-{new Date().getFullYear()} Villanykari Szakestély</p>
            </footer>
        );
    }
}

export default Footer;